(() => {
  const stateByProduct = window.GardeniaGiftStateV4 || (window.GardeniaGiftStateV4 = {});

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function ensurePropertyInput(form, key, propertyName) {
    let input = form.querySelector('input[data-gardenia-property="' + key + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.dataset.gardeniaProperty = key;
      form.appendChild(input);
    }
    input.name = 'properties[' + propertyName + ']';
    return input;
  }

  function initProduct(productInfo) {
    if (productInfo.querySelector('.gardenia-gift-fields')) return;

    const cardChoiceRoot = productInfo.querySelector('[data-gardenia-card-choice]');
    if (!cardChoiceRoot) return;

    const form = productInfo.querySelector('product-form form');
    if (!form || !form.id) return;

    const buyButtons = productInfo.querySelector('product-form');
    if (!buyButtons || !buyButtons.parentNode) return;

    const sectionKey = productInfo.dataset.section || productInfo.id.replace(/^MainProduct-/, '') || 'main';
    const safeSectionKey = escapeHtml(sectionKey);
    const safeFormId = escapeHtml(form.id);
    const productId = productInfo.dataset.productId || productInfo.id || 'product';
    const state = stateByProduct[productId] || (stateByProduct[productId] = { card: '', recipient: '', sender: '' });

    const wrapper = document.createElement('div');
    wrapper.className = 'gardenia-gift-fields';
    wrapper.innerHTML = `
      <div class="gardenia-gift-field">
        <div class="gardenia-step-heading">
          <span class="gardenia-step-heading__number">4</span>
          <div>
            <h3>Your message</h3>
            <p>We’ll handwrite this exactly as you enter it.</p>
          </div>
        </div>

        <div class="field">
          <textarea
            id="Card-Message-${safeSectionKey}"
            data-gardenia-gift-field="card"
            class="text-area field__input product-form__gift-message"
            form="${safeFormId}"
            rows="5"
            maxlength="250"
            required
            aria-required="true"
            placeholder="Write your message here…"
          ></textarea>
        </div>

        <div class="product-form__gift-meta-row">
          <p class="product-form__field-note">Your message will be written in the card you selected above.</p>
          <p class="product-form__char-count" data-gardenia-char-count>250 characters remaining</p>
        </div>

        <div class="gardenia-gift-fields__names">
          <div class="gardenia-gift-fields__name-field">
            <label for="Recipient-Name-${safeSectionKey}">Recipient name</label>
            <div class="field">
              <input
                type="text"
                id="Recipient-Name-${safeSectionKey}"
                data-gardenia-gift-field="recipient"
                class="field__input"
                form="${safeFormId}"
                required
                aria-required="true"
                autocomplete="off"
                placeholder="Who are the flowers for?"
              >
            </div>
          </div>

          <div class="gardenia-gift-fields__name-field">
            <label for="Sender-Name-${safeSectionKey}">Sender name</label>
            <div class="field">
              <input
                type="text"
                id="Sender-Name-${safeSectionKey}"
                data-gardenia-gift-field="sender"
                class="field__input"
                form="${safeFormId}"
                required
                aria-required="true"
                autocomplete="off"
                placeholder="Who are they from?"
              >
            </div>
          </div>
        </div>
      </div>
    `;

    buyButtons.parentNode.insertBefore(wrapper, buyButtons);

    const propertyInputs = {
      card: ensurePropertyInput(form, 'card', 'Card Message'),
      recipient: ensurePropertyInput(form, 'recipient', 'Recipient Name'),
      sender: ensurePropertyInput(form, 'sender', 'Sender Name')
    };

    const cardField = wrapper.querySelector('[data-gardenia-gift-field="card"]');
    const recipientField = wrapper.querySelector('[data-gardenia-gift-field="recipient"]');
    const senderField = wrapper.querySelector('[data-gardenia-gift-field="sender"]');
    const countEl = wrapper.querySelector('[data-gardenia-char-count]');

    cardField.value = state.card || '';
    recipientField.value = state.recipient || '';
    senderField.value = state.sender || '';

    propertyInputs.card.value = cardField.value;
    propertyInputs.recipient.value = recipientField.value;
    propertyInputs.sender.value = senderField.value;

    const updateCard = () => {
      state.card = cardField.value;
      propertyInputs.card.value = cardField.value;
      cardField.setCustomValidity('');
      countEl.textContent = Math.max(0, 250 - cardField.value.length) + ' characters remaining';
    };

    const updateRecipient = () => {
      state.recipient = recipientField.value;
      propertyInputs.recipient.value = recipientField.value;
      recipientField.setCustomValidity('');
    };

    const updateSender = () => {
      state.sender = senderField.value;
      propertyInputs.sender.value = senderField.value;
      senderField.setCustomValidity('');
    };

    cardField.addEventListener('input', updateCard);
    recipientField.addEventListener('input', updateRecipient);
    senderField.addEventListener('input', updateSender);

    updateCard();
    updateRecipient();
    updateSender();

    form.addEventListener('submit', (event) => {
      const fields = [
        [cardField, 'Please enter a card message.'],
        [recipientField, 'Please enter the recipient name.'],
        [senderField, 'Please enter the sender name.']
      ];

      for (const [field, message] of fields) {
        if (field.value.trim() !== '') {
          field.setCustomValidity('');
          continue;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        field.setCustomValidity(message);
        field.focus();
        field.reportValidity();
        field.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
    }, true);
  }

  function initAll() {
    document.querySelectorAll('product-info').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();